import { Link } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import logo from "../../assets/images/official.png";
import group from "../../assets/images/karimjee.png";
import spin from "../../assets/spin.svg";
import "../../waves.css";
import { BiChevronLeft } from "react-icons/bi";
import postDataTrace from "../../services/postDataTrace";
import { Input, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { AuthContext } from "../../contexts/AuthContext";
import { BsCalendar2Check } from "react-icons/bs";

export default function Signin() {
  const { signin } = useContext(AuthContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSpinning, setSpinning] = useState(false);

  useEffect(() => {
    if (email.trim() && password.trim()) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [email, password]);

  const handleSignin = async (e: any) => {
    setSpinning(true);
    e.preventDefault();
    const data = { username: email, password };
    const uri = `auth/login`;
    const response = await postDataTrace(data, uri);

    if (response.statusCode === 401) {
      message.error("Incorrect email or password");
      setSpinning(false);

      return;
    }

    if (!response?.user?.isActive) {
      message.error("Sorry, Your account is not active");
      setSpinning(false);

      return;
    }
    signin(response);
    message.success(`Logged in sucessfully`);
    setSpinning(false);
  };

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13 || e.which === 13) {
      isButtonDisabled || handleSignin(e);
    }
  };

  return (
    <div className="header">
      <div className="inner-header flexo">
        <div className="max-w-2xl w-full pt-24 sm:pt-24 px-5">
          <div className="flex flex-row justify-center w-full">
            <div className="w-full sm:w-1/2 p-4 bg-gray-100 rounded-tl-lg rounded-bl-lg">
              <div className="text-center mt-4">
                <img className="mx-auto h-32 w-auto " src={logo} alt="" />
                <p>Sign in with email and password </p>
              </div>
              <div className="mb-4">
                <form className="mt-2">
                  <input type="hidden" name="remember" value="true" />
                  <div className="rounded-md shadow-sm">
                    <div>
                      <Input
                        aria-label="Email"
                        name="email"
                        type="text"
                        size="large"
                        required
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        className="flex flex-row justify-center"
                        placeholder="Email"
                      />
                    </div>
                    <div className="-mt-px">
                      <Input.Password
                        aria-label="Password"
                        name="password"
                        type="password"
                        size="large"
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        className="flex flex-row justify-center"
                        placeholder="Password"
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                      />
                    </div>
                  </div>

                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <input
                        id="remember_me"
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      />
                      <label className="ml-1 mr-1 block text-sm leading-5 text-gray-900">
                        Remember me
                      </label>
                    </div>
                    <Link
                      to="/forgot"
                      className="text-xs text-center flex items-center text-gray-800 hover:text-toyota"
                    >
                      Forgot your Password?
                    </Link>
                  </div>

                  <div className="flex justify-between">
                    <Link
                      to="/"
                      className="text-xs text-center flex items-center text-karimjee hover:text-toyota mt-2 py-2 rounded-md"
                    >
                      <BiChevronLeft size={20} />
                      Go to Welcome Screen
                    </Link>
                    <Link
                      to="/wall"
                      className="text-xs text-center flex items-center text-karimjee hover:text-toyota mt-2 py-2 rounded-md"
                    >
                      <span className="ml-1">Booking Screen</span>
                    </Link>
                  </div>

                  <div className="border-t border-gray-300  max-w-md mt-2 mb-4 w-full"></div>

                  <div className="mt-4 mb-4">
                    <button
                      onClick={(e: any) => handleSignin(e)}
                      className="group relative w-full flex justify-center py-3 sm:py-2 px-4
                border border-transparent text-sm leading-5 font-medium
                rounded-md text-white bg-toyota hover:bg-red-700
                focus:outline-none focus:border-toyota
                focus:shadow-outline-indigo active:bg-toyota transition
                duration-150 ease-in-out"
                    >
                      <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                        <svg
                          className="h-5 w-5 text-white group-hover:text-whitetransition ease-in-out duration-150"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                          />
                        </svg>
                      </span>
                      {isSpinning ? (
                        <span>
                          <img
                            src={spin}
                            alt="spin"
                            height="20px"
                            width="20px"
                          />
                        </span>
                      ) : (
                        <span className="text-white">Sign in</span>
                      )}
                    </button>
                  </div>
                  <div className="border-t border-gray-300  max-w-md mt-2 mb-4 w-full"></div>

                  <div className="flex justify-center items-center text-gray-600 text-xs">
                    <div className="">Don't have an account ? </div>
                    <Link
                      to="/register"
                      className="text-xs text-center flex items-center text-karimjee hover:text-toyota ml-1"
                    >
                      Sign up
                    </Link>
                  </div>
                </form>
              </div>
            </div>
            <div className="w-0 bg-white sm:w-1/2 rounded-tr-lg rounded-br-lg flex">
              <div className="flex flex-col justify-center items-center  w-full">
                <img src={group} className="w-32" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <svg
          className="waves"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g className="parallax">
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </div>
  );
}
